import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { Action } from "../../types/toolbar";
import CustomModal from "../../components/ui/modal/modal.component";
import ProducerForm from "../../components/ui/producerForm/producerForm.component";
import { useHasPermission } from "../../contexts/auth";

export const ProducersListActions = () => {
  const { t } = useTranslation();
  const [addProducerOpened, setAddProducerOpened] = useState(false);
  const canAddProducer = useHasPermission("settlement.add_equipmentproducer");

  const handleProducerAdded = () => {
    setAddProducerOpened(false);
    window.dispatchEvent(new Event("equipmentProducerAdded"));
  };

  const actions: Action[] = [
    {
      icon: <AddIcon />,
      label: t("Add producer"),
      onClick: () => setAddProducerOpened(true),
      disabled: !canAddProducer,
    },
  ];

  return (
    <>
      <Toolbar actions={actions} />
      <CustomModal
        opened={addProducerOpened}
        setOpened={setAddProducerOpened}
        title={t("Add producer")}
        content={<ProducerForm onSuccess={handleProducerAdded} />}
      />
    </>
  );
};
